const React = require('react');
const withState = require('../../../../../../utils/withState');
const {BtnDeletable} = require('../../../Buttons');
const UserRegistrationFooter = require('../UserRegistrationFooter');

module.exports = withState((setState, self) => {
  self.state = {
    ...self.state,
    docsList: [
      {id: '1', title: 'Proof_of_addressssssss'},
      {id: '2', title: 'Proof1_of_addressssssss'}
    ]
  }

  const onItemDelete = (id) => () => {
    const docsList = self.state.docsList.filter((el) => el.id !== id);
    setState({docsList})
  }

  return (state, props) => {
    return (
      <>
        <p className="mb10 f16 lh24">
          Do you feel any other document will help us speed up onboarding process?<br/>
          Please upload using link below
        </p>
        <div className="layoutRow aiC mh-9 mt28 (w224|ph9)>1">
          {(state.docsList || []).map(({id, title}) => (
            <div key={id}>
              <BtnDeletable
                onDelete={onItemDelete(id)}
              >
                {title}
              </BtnDeletable>
            </div>
          ))}
          <div>
            <BtnDeletable
              onClick={() => console.log('upload')}
              isActive
            >
              UPLOAD FILE
            </BtnDeletable>
          </div>
        </div>
        <UserRegistrationFooter onNextStep={props.onNextStep} />
      </>
    )
  }
})
